import { getFolders } from "../api/folder.services.ts"
import { type FolderListParams } from "../types/folder.types.ts"

const FOLDERS_PER_REQUEST = 200

type FolderListResponse = Awaited<ReturnType<typeof getFolders>>

/** Every folder matching `params`, however many pages the server splits them into. */
export const listEveryFolder = async (
  params: Omit<FolderListParams, "page" | "page_size">
): Promise<FolderListResponse> => {
  const pageOf = (page: number) =>
    getFolders({ ...params, page, page_size: FOLDERS_PER_REQUEST })

  const first = await pageOf(1)
  if (!first.ok || !first.data) return first

  const results = [...first.data.results]
  let { next } = first.data
  for (let page = 2; next; page++) {
    const response = await pageOf(page)
    if (!response.ok || !response.data) return response
    results.push(...response.data.results)
    next = response.data.next
  }
  return { ...first, data: { ...first.data, results, next: null } }
}
